// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  justify-content: space-around;
  padding: 2rem 4rem 4rem 4rem;
}
:host .side-panel-footer {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/shared/overlay-side-panel/components/overlay-side-panel-footer/overlay-side-panel-footer.component.ts"],"names":[],"mappings":"AACM;EACE,aAAA;EACA,6BAAA;EACA,4BAAA;AAAR;AAEQ;EACE,WAAA;AAAV","sourcesContent":["\n      :host {\n        display: flex;\n        justify-content: space-around;\n        padding: 2rem 4rem 4rem 4rem;\n\n        .side-panel-footer {\n          width: 100%;\n        }\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
